<div class="registration-container">
  <div class="form-section">
    <img src="assets/new-logo-2.png" alt="Bipperz logo" class="logo"/>
    <h2 class="welcome-title">{{ 'registration.welcome_title' | translate }}</h2>

    <p class="login-text">
      {{ 'registration.already_have_account' | translate }}
      <a class="login-link" routerLink="/login">{{ 'registration.login' | translate }}</a>
    </p>

    <form [formGroup]="form">
      <div class="input-row">
        <app-input
          style="flex: 1;"
          formControlName="firstname"
          [withNoIcon]="true"
          [state]="InputState.REGULAR"
          [placeholder]="'registration.first_name' | translate"
          [size]="InputSize.LARGER"
        ></app-input>

        <app-input
          style="flex: 1;"
          formControlName="familyname"
          [withNoIcon]="true"
          [placeholder]="'registration.last_name' | translate"
          [size]="InputSize.LARGER"
          [state]="InputState.REGULAR"
        ></app-input>
      </div>

      <div class="email-field">
        <div class="input-email">
          <app-input
            [leftIcon]="'Mail'"
            [placeholder]="'registration.email_placeholder' | translate"
            [showLabel]="true"
            [showLeftIcon]="true"
            [size]="isMobile ? InputSize.LARGE : InputSize.LARGER"
            [state]="InputState.REGULAR"
            formControlName="email"
          ></app-input>

          <mat-error>
            <div *ngIf="isInvalidAndTouched('email')" class="error-message">
              <span *ngIf="form.get('email')?.errors?.['required']">
                {{ 'errors.email_required' | translate }}
              </span>
              <span *ngIf="form.get('email')?.errors?.['email']">
                {{ 'errors.email_valid' | translate }}
              </span>
            </div>
          </mat-error>
        </div>
      </div>

      <div class="policy-checkbox-wrapper">
        <label class="custom-checkbox">
          <input type="checkbox" formControlName="termsAccepted" />
          <span class="checkbox-box">
            <span class="checkbox-tick"></span>
          </span>

          <span class="checkbox-label">
            {{ 'registration.i_agree_to_the' | translate }}
            <button
              type="button"
              class="policy-link"
              (click)="openPolicyModal('terms_of_services'); $event.preventDefault(); $event.stopPropagation()"
            >
              {{ 'registration.terms_of_service' | translate }}
            </button>
            {{ 'registration.and' | translate }}
            <button
              type="button"
              class="policy-link"
              (click)="openPolicyModal('privacy_policy'); $event.preventDefault(); $event.stopPropagation()"
            >
              {{ 'registration.privacy_policy' | translate }}
            </button>
            {{ 'registration.of_bipperz' | translate }}
          </span>
        </label>

        <mat-error *ngIf="isInvalidAndTouched('termsAccepted')" class="checkbox-error">
          {{ 'registration.errors.accept_terms_required' | translate }}
        </mat-error>
      </div>

      <app-button
        (click)="openPasswordForm()"
        [isFullWidth]="true"
        [label]="'registration.continue' | translate"
        [size]="ButtonSize.LARGER"
        [state]="form.valid ? ButtonState.REGULAR : ButtonState.DISABLED"
        [type]="ButtonType.PRIMARY"
      ></app-button>
    </form>

    <div class="social-divider">
      <img src="assets/Line.svg" alt=""/>
      <span>{{ 'login_modal.continue_span' | translate }}</span>
      <img src="assets/Line.svg" alt=""/>
    </div>

    <div class="social-register-buttons">
      <app-button
        (click)="registerWithGoogle()"
        [isFullWidth]="true"
        [label]="'login_modal.register_google' | translate"
        [leftIcon]="'assets/icons/google.svg'"
        [showLeftIcon]="true"
        [size]="ButtonSize.LARGER"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.SECONDARY"
      ></app-button>

      <app-button
        (click)="registerWithApple()"
        [isFullWidth]="true"
        [label]="'login_modal.register_apple' | translate"
        [leftIcon]="'assets/icons/apple.svg'"
        [showLeftIcon]="true"
        [size]="ButtonSize.LARGER"
        [state]="isSocialLoading ? ButtonState.DISABLED : ButtonState.REGULAR"
        [type]="ButtonType.SECONDARY"
      ></app-button>
    </div>
  </div>
</div>
